import { InjectionToken } from '@angular/core';
import { NumberFormatter } from '../interfaces/number-formatter.interface';

export const NUMBER_FORMATTER = new InjectionToken<NumberFormatter>('NUMBER_FORMATTER');
